const data = [
  {
    id: 1,
    name: 'Francesco Robiola',
    state: 'No pain no Gain, only gym in my life!',
    img: 'https://res.cloudinary.com/thomasdea/image/upload/v1612341193/react-api-course/tizio-palestra_naoqwo.jpg',
  },
  {
    id: 2,
    name: 'Sabrina Cortelli',
    state: 'Music is to the soul what gymnastics is to the body.',
    img: 'https://res.cloudinary.com/thomasdea/image/upload/v1612341197/react-api-course/tizia-cuffie_xf2bae.jpg',
  },
  {
    id: 3,
    name: 'Mike Russel',
    state: "Don't let anyone tell you you're not capable.",
    img: 'https://res.cloudinary.com/thomasdea/image/upload/v1612341184/react-api-course/tizio-giacca_jvzktv.jpg',
  },
  {
    id: 4,
    name: 'Rebecca Orlando',
    state:
      'Photography is passion and love, it is the passing emotion that arrives and immediately flies away.',
    img: 'https://res.cloudinary.com/thomasdea/image/upload/v1612341204/react-api-course/tipa-occhiali_svc9jp.jpg',
  },
  {
    id: 5,
    name: 'Crhistian Minerva',
    state: "I wouldn't eat a hamburger if they paid me $40,000.",
    img: 'https://res.cloudinary.com/thomasdea/image/upload/v1612341200/react-api-course/tizio_awlq7r.jpg',
  },
];

export default data;
